import React, { useState, useCallback } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Menu,
  List,
  ListItem,
  ListItemButton,
  ListItemSecondaryAction,
  ListItemText,
  Button,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import formIcon from "../../../../../assets/images/docs/formIcon.png";
import {
  DownloadBoxIcon,
  SignatureIcon,
  InitialIcon,
  TextBoxIcon,
  DateIcon,
  CheckBoxIcon,
  DragIcon,
} from "./icons.js";
import { useSelector } from "react-redux";
import { handleGetUsers } from "../utils.js";
const zoomOptions = [50, 75, 100, 125, 150, 175, 200];
const tabs = [
  {
    title: "Signature",
    icon: <SignatureIcon />,
    width: "160px",
    height: "36px",
  },
  {
    title: "Initial",
    icon: <InitialIcon />,
    width: "60px",
    height: "36px",
  },
  {
    title: "TextBox",
    icon: <TextBoxIcon />,
    width: "160px",
    height: "36px",
  },
  {
    title: "Date",
    icon: <DateIcon />,
    width: "160px",
    height: "36px",
  },
  {
    title: "Checkbox",
    icon: <CheckBoxIcon />,
    width: "30px",
    height: "30px",
    resizable: true,
  },
];

function TabsHeader(props) {
  const [activeTab, setActiveTab] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const docDetail = useSelector((item) => item.Docs.docDetail);

  const { classes } = props;

  const handleClose = () => {
    setAnchorEl(null);
    setActiveTab("");
  };

  const handleDragStart = (e, user, tabType = null) => {
    setAnchorEl(null);

    // Create a draggable element with tab and user info
    if (!user) return;

    // Set the drag data
    const dragData = {
      tabType: tabType || activeTab,
      user: user,
    };

    e.dataTransfer.setData("text/plain", JSON.stringify(dragData));

    // Create a transparent drag image initially
    const dragImage = document.createElement("div");
    dragImage.textContent = `${activeTab} - ${
      user.full_name || user.first_name
    }`;
    dragImage.style.backgroundColor = "transparent";
    dragImage.style.color = "transparent";
    dragImage.style.padding = "10px";
    dragImage.style.borderRadius = "4px";
    dragImage.style.position = "absolute";
    dragImage.style.top = "-1000px";
    document.body.appendChild(dragImage);

    e.dataTransfer.setDragImage(dragImage, 0, 0);

    // Remove the element after drag ends
    setTimeout(() => {
      document.body.removeChild(dragImage);
    }, 0);

    // Create a floating element that will follow the cursor only when over document
    const floatingElement = document.createElement("div");
    floatingElement.id = "floating-drag-element";
    floatingElement.style.position = "fixed";
    floatingElement.style.backgroundColor = "#e6eaff";
    floatingElement.style.color = "#2868d7";
    floatingElement.style.border = "1px solid #2868d7";
    floatingElement.style.borderRadius = "2px";
    floatingElement.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
    floatingElement.style.pointerEvents = "none";
    floatingElement.style.zIndex = "9999";
    floatingElement.style.display = "flex";
    floatingElement.style.flexDirection = "column";
    floatingElement.style.gap = "2px";
    floatingElement.style.alignItems = "center";
    floatingElement.style.justifyContent = "center";
    floatingElement.style.padding = "5px";
    floatingElement.style.boxSizing = "border-box";
    floatingElement.style.overflow = "hidden";

    // Create and add the icon
    const iconElement = document.createElement("div");
    iconElement.style.height = "16px";
    iconElement.style.width = "100%";
    iconElement.style.display = "flex";
    iconElement.style.alignItems = "center";
    iconElement.style.justifyContent = "center";

    // Find the tab to get its icon
    const currentTab = tabs.find((tab) => tab.title === activeTab);
    if (currentTab && currentTab.icon) {
      // Clone the SVG icon
      const tabIcon = document
        .querySelector(`[data-tab-title="${activeTab}"] svg`)
        .cloneNode(true);
      // Set the stroke color to match the tab style
      const paths = tabIcon.querySelectorAll("g, path");
      paths.forEach((path) => {
        if (path.getAttribute("stroke")) {
          path.setAttribute("stroke", "#2868d7");
        }
      });

      // Set SVG size to ensure proper centering
      tabIcon.style.width = "16px";
      tabIcon.style.height = "16px";
      tabIcon.setAttribute("width", "16");
      tabIcon.setAttribute("height", "16");

      iconElement.appendChild(tabIcon);
    }

    // Create text element
    const textElement = document.createElement("div");
    textElement.textContent = activeTab;
    textElement.style.fontSize = "10px";
    textElement.style.lineHeight = "12px";
    textElement.style.textAlign = "center";
    textElement.style.width = "100%";
    textElement.style.display = "flex";
    textElement.style.alignItems = "center";
    textElement.style.justifyContent = "center";
    if (activeTab === "Signature") {
      textElement.textContent = `${user?.first_name || ""} ${
        user?.last_name || ""
      }`;
    }
    if (activeTab === "Initial") {
      textElement.textContent = `${user?.first_name?.slice(0, 1) || ""}${
        user?.last_name?.slice(0, 1) || ""
      }`;
    }

    // Add elements to floating element
    floatingElement.appendChild(iconElement);
    floatingElement.appendChild(textElement);

    // Set different dimensions based on tab type - reduced by 10px

    if (currentTab) {
      // Get dimensions from tab definition and reduce by 10px
      const width = parseInt(currentTab.width);
      const height = parseInt(currentTab.height);

      floatingElement.style.width = `${width}px`;
      floatingElement.style.height = `${height}px`;
    } else {
      // Fallback dimensions
      if (
        activeTab === "Signature" ||
        activeTab === "TextBox" ||
        activeTab === "Date"
      ) {
        floatingElement.style.width = "160px";
        floatingElement.style.height = "36px";
      } else if (activeTab === "Initial") {
        floatingElement.style.width = "60px";
        floatingElement.style.height = "36px";
      } else if (activeTab === "Checkbox") {
        floatingElement.style.width = "20px";
        floatingElement.style.height = "20px";
      }
    }

    document.body.appendChild(floatingElement);
  };

  const handleDragEnd = () => {
    // Remove the floating element when drag ends
    const floatingElement = document.getElementById("floating-drag-element");
    if (floatingElement) {
      document.body.removeChild(floatingElement);
    }
  };

  return (
    <Box className={classes.root}>
      {" "}
      <Box className={classes.tabsLeft}>
        <TextField
          select
          size="small"
          defaultValue="sort"
          className={classes.selectBox}
        >
          <MenuItem disabled value="sort" sx={{ fontSize: "12px" }}>
            Sort
          </MenuItem>
          {zoomOptions?.map((option, i) => (
            <MenuItem value={option} sx={{ fontSize: "12px" }}>
              {option}%
            </MenuItem>
          ))}
        </TextField>
        <Box className={classes.buttonItem}>
          <img className={classes.buttonIcon} src={formIcon} alt="folderIcon" />
          <Typography className={classes.buttonText}>Form</Typography>
        </Box>
      </Box>
      <Box className={classes.tabsArea}>
        {tabs?.map((tab, index) => (
          <Box
            key={index}
            data-tab-title={tab.title}
            onClick={(e) => {
              setActiveTab(tab.title);
              setAnchorEl(e.currentTarget);
            }}
            className={
              tab.title === activeTab
                ? classes.buttonItemActive
                : classes.buttonItem
            }
          >
            {tab?.icon ? tab?.icon : <DownloadBoxIcon />}
            <Typography className={classes.buttonText}>{tab?.title}</Typography>
          </Box>
        ))}
      </Box>
      <Box className={classes.tabsLeft}>
        <Box className={classes.buttonItem}>
          <DownloadBoxIcon />
          <Typography className={classes.buttonText}>Download</Typography>
        </Box>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            border: "2px solid #2868D7",
          },
          "& .MuiList-padding": {
            padding: "0px !important",
          },
        }}
      >
        <Box className={classes.menuCard}>
          <List disablePadding dense>
            {handleGetUsers(docDetail?.data)?.map((user, index) => (
              <ListItem divider disablePadding key={index}>
                <ListItemButton
                  draggable={true}
                  onDragStart={(e) => handleDragStart(e, user)}
                  onDragEnd={handleDragEnd}
                  onClick={(e) => {
                    // Create a synthetic drag event to reuse handleDragStart
                    const syntheticEvent = {
                      dataTransfer: {
                        setData: () => {},
                        setDragImage: () => {},
                      },
                    };
                    handleDragStart(syntheticEvent, user);
                    // Close the menu after clicking
                    handleClose();
                  }}
                >
                  <ListItemText>
                    {user?.full_name || user?.first_name} ({user?.userType})
                  </ListItemText>
                  <ListItemSecondaryAction>
                    <Button
                      className={classes.editButton}
                      size="small"
                      variant="text"
                    >
                      Edit
                    </Button>
                  </ListItemSecondaryAction>
                </ListItemButton>
              </ListItem>
            ))}

            <ListItem disablePadding sx={{ height: "30px" }}>
              <ListItemSecondaryAction>
                <Button
                  className={classes.editButton}
                  size="small"
                  variant="text"
                >
                  Add User
                </Button>
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        </Box>
      </Menu>
    </Box>
  );
}

export default withStyles(styleSheet, { name: "TabsHeaderStyle" })(TabsHeader);
